import { Box, CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import baseApi from 'shared/utils/baseApi';
import { IPdfViewProps, PdfView } from 'shared/components/PdfViewer/PdfView';

interface IAuthenticatedPdfViewProps extends IPdfViewProps {
    errorRender?: React.ReactElement;
}

export const AuthenticatedPdfView = ({
    filePath,
    errorRender,
    ...props
}: IAuthenticatedPdfViewProps) => {
    const [objectUrl, setObjectUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        let isMounted = true;
        let currentObjectUrl: string | null = null;

        setObjectUrl(null);
        setIsLoading(true);
        setIsError(false);

        baseApi.get<Blob>(filePath, undefined, { responseType: 'blob' })
            .then(({ data }) => {
                const downloadedObjectUrl = window.URL.createObjectURL(data);
                if (isMounted) {
                    currentObjectUrl = downloadedObjectUrl;
                    setObjectUrl(currentObjectUrl);
                } else {
                    window.URL.revokeObjectURL(downloadedObjectUrl);
                }
            })
            .catch(() => {
                if (isMounted) {
                    setIsError(true);
                }
            })
            .finally(() => {
                if (isMounted) {
                    setIsLoading(false);
                }
            });

        return () => {
            isMounted = false;
            if (currentObjectUrl) {
                window.URL.revokeObjectURL(currentObjectUrl);
            }
        };
    }, [filePath]);

    if (isLoading) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
                height="100%"
            >
                <CircularProgress />
            </Box>
        );
    }

    if (isError || !objectUrl) {
        return errorRender || null;
    }

    return <PdfView {...props} filePath={objectUrl} />;
};
